<template>
    <div class="p-bar">
        <ul>
            <li :class="currentStep === step ? 'current' : ''" v-for="(step, index) in stepLength" :key="index"></li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    currentStep: Number,
    stepLength: Number
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
